let lastScrollTop = 0;

(function () {
	const mainHeader = document.getElementById('header');
	window.onload = function () {
		// RELLAX
		if (document.body.offsetWidth > 990) {
			const rellax = new Rellax('.js-rellax', { center: true });
		}

		// MODULE GROUPS SUB OFFSET
		document.querySelectorAll('.js-suboffset-bg.group-start').forEach((group) => {
			addSuboffsetBg(group);
			setSuboffsetBgPosition(group);
		});

		window.addEventListener('resize', () => {
			document.querySelectorAll('.js-suboffset-bg.group-start').forEach((group) => {
				setSuboffsetBgPosition(group);
			});
		});

		scrollW(mainHeader);
		window.addEventListener('scroll', () => {
			document.querySelectorAll('.js-suboffset-bg.group-start').forEach((group) => {
				setSuboffsetBgPosition(group);
			});

			scrollW(mainHeader);
		});
	};
})();

function scrollW(header, startFrom = 80) {
	//SET HEADER SCROLLING CLASSES
	const scrollTop = document.documentElement.scrollTop;

	header.classList.toggle('scroll', scrollTop > startFrom);
	header.classList.toggle('down', scrollTop > startFrom && scrollTop > lastScrollTop);
	header.classList.toggle('up', scrollTop > startFrom && scrollTop < lastScrollTop);

	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // CHECK MOBILE NEGATIVE SCROLLING
}

function addSuboffsetBg(group) {
	const mods = group.children;

	const firstMod = mods[0];
	const lastMod = mods[mods.length - 1];
	firstMod.classList.add('suboffset-firstMod');
	lastMod.classList.add('suboffset-lastMod');

	group.insertAdjacentHTML('afterbegin', `<div data-fromjs class="suboffset-bg" style="${group.getAttribute('style')}"></div>`);
}

function setSuboffsetBgPosition(group) {
	const titles = group.querySelectorAll('.titles');
	const firstTitle = titles[0];
	const lastTitle = titles[titles.length - 1];

	const groupTop = group.getBoundingClientRect().top + window.scrollY;
	const groupBottom = group.getBoundingClientRect().bottom + window.scrollY;

	const firstTitleBottom = firstTitle.getBoundingClientRect().bottom + window.scrollY - groupTop;
	const lastTitleBottom = groupBottom - (lastTitle.getBoundingClientRect().bottom + window.scrollY);

	const bgOffsetTop = firstTitleBottom || 0;
	const bgOffsetBottom = lastTitle !== firstTitle ? lastTitleBottom : 0;

	group.querySelector('.suboffset-bg').style.top = group.classList.contains('top') ? 0 : `${bgOffsetTop}px`;
	group.querySelector('.suboffset-bg').style.bottom = group.classList.contains('bottom') ? 0 : `${bgOffsetBottom}px`;
}
